export default {
    general: {
        token: '_dashboard_v6',
        intended_url: null,
        api_version: 'v2',
        return_path: 'return_path',
    },
    default_language: {
        name: "English",
        code: "en-US",
        is_rtl: false,
    },
};